import { __awaiter, __decorate, __metadata } from "tslib";
import { Mutation, Action, VuexModule, Module } from 'vuex-module-decorators';
import ApiService from '@/core/services/ApiService';
import Func from '@/views/pscm/requisition/functionhelpers.js';
let CrfApprovalModule = class CrfApprovalModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.approvalCrf = {};
        this.picBudgetFile = [];
        this.eligable = false;
        this.callbackError = {};
        this.lookupRental = [];
        this.lookupOutstanding = [];
        this.submitDialogApproval = false;
        this.submitPicProcDialog = false;
        this.submitClickApproval = false;
        this.completeInputMf = true;
        this.highlightMf = true;
        this.approvalRemarkReq = true;
    }
    get getCallbackError() {
        return this.callbackError;
    }
    get getApprovalCrf() {
        return this.approvalCrf;
    }
    get getEligable() {
        return this.eligable;
    }
    get getPicBudgetFile() {
        return this.picBudgetFile;
    }
    get getLookupRental() {
        return this.lookupRental;
    }
    get getLookupOutstanding() {
        return this.lookupOutstanding;
    }
    get getSubmitDialogApproval() {
        return this.submitDialogApproval;
    }
    get getSubmitPicProcDialog() {
        return this.submitPicProcDialog;
    }
    get getSubmitClickApproval() {
        return this.submitClickApproval;
    }
    get getCompleteInputMf() {
        return this.completeInputMf;
    }
    get getHighlightMf() {
        return this.highlightMf;
    }
    get getApprovalRemarkReq() {
        return this.approvalRemarkReq;
    }
    ['setApprovalCrf'](data) {
        this.approvalCrf = data;
    }
    ['setPicBudgetFile'](data) {
        this.picBudgetFile.push(data);
    }
    ['setPicBudgetFileClear']() {
        this.picBudgetFile = [];
    }
    ['setEligable'](data) {
        this.eligable = data;
    }
    ['setCallbackError'](data) {
        this.callbackError = data;
    }
    ['setLookupRental'](data) {
        this.lookupRental = data;
    }
    ['setLookupOutstanding'](data) {
        this.lookupOutstanding = data;
    }
    ['setSubmitDialogApproval'](data) {
        this.submitDialogApproval = data;
    }
    ['setSubmitPicProcDialog'](data) {
        this.submitPicProcDialog = data;
    }
    ['setSubmitClickApproval'](data) {
        this.submitClickApproval = data;
    }
    ['setCompleteInputMf'](data) {
        this.completeInputMf = data;
    }
    ['setHighlightMf'](data) {
        this.highlightMf = data;
    }
    ['setApprovalRemarkReq'](data) {
        this.approvalRemarkReq = data;
    }
    ['getApprovalCrfModule'](xToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const getHeaderId = window.location.href.split('/');
            const headerId = getHeaderId.pop();
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/detail/approval?headerID=` +
                headerId +
                '&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.get(apiUrl)
                    .then((response) => {
                    this.context.commit('setIsLoading', false);
                    const data = response.data.result.content;
                    if (response.data.result.isError) {
                        this.context.commit('setShowErrorDialog', true);
                        const dataError = {
                            conditions: false,
                            message: response.data.result.message,
                            isField: false
                        };
                        this.context.commit('setIsSubmitError', dataError);
                    }
                    else {
                        data.extensionPeriod = Func.currencyFormat(data.extensionPeriod);
                        data.contractPeriod = Func.currencyFormat(data.contractPeriod, true);
                        data.picprcPeriode = Func.currencyFormat(data.picprcPeriode);
                        const searchSummaryFiles = data.listAttachments.filter((s) => {
                            return s.attachmentType == 'SUMMARYBUDGET';
                        });
                        this.context.commit('setPicBudgetFileClear');
                        searchSummaryFiles.forEach((g) => {
                            this.context.commit('setPicBudgetFile', g);
                        });
                        let spendingValue = '';
                        if (data.picprcSpendingValue !== '' &&
                            data.picprcSpendingValue !== null) {
                            spendingValue = Func.format2(data.picprcSpendingValue.toString());
                        }
                        const listItems = data.listItems.map((g) => {
                            return Object.assign(Object.assign({}, g), { isMutationFromTouched: false, isMutationQuantityTouched: false, isRentalTouched: false, picprcSpendingValue: spendingValue });
                        });
                        listItems.forEach((g) => {
                            g.quantity = Func.currencyFormat(g.quantity);
                            g.period = Func.currencyFormat(g.period, true);
                            g.mutationQuantity = Func.currencyFormat(g.mutationQuantity);
                            g.newOrderQuantity = Func.currencyFormat(g.newOrderQuantity);
                            g.listSubitems.forEach((sg) => {
                                sg.quantity = Func.currencyFormat(sg.quantity);
                            });
                        });
                        this.context.commit('setApprovalCrf', Object.assign(Object.assign({}, data), { picprcSpendingValue: spendingValue, remarks: '', listItems, isSummaryBudgetTouched: false, isApprovalRemarkTouched: false }));
                        this.context.commit('setEligable', true);
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['uploadPicBudgetFile'](file) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/upload?module=JCI&ver=v1`;
            // eslint-disable-next-line prefer-const, no-var
            let dataForm = new FormData();
            dataForm.append('file', file.files);
            return yield new Promise((resolve, reject) => {
                ApiService.postImages(apiUrl, dataForm)
                    .then((response) => {
                    const data = response.data.result.content;
                    const fileName = `${data.originalFileName}.${data.fileType}`;
                    const getFile = this.picBudgetFile.findIndex((s) => {
                        return s.originalFileName == fileName;
                    });
                    if (getFile >= 0) {
                        this.picBudgetFile[getFile] = Object.assign(Object.assign({}, data), { isSuccessDownload: false, isFailedDownload: false, isDownloading: false });
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['deleteFilePicBudget'](fileUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/upload?fileUrl=` +
                fileUrl +
                '&module=JCI&ver=v1';
            return yield new Promise((resolve, reject) => {
                ApiService.delete(apiUrl)
                    .then(() => {
                    // eslint-disable-next-line no-var
                    const index = this.picBudgetFile
                        .map((x) => {
                        return x.fileUrl;
                    })
                        .indexOf(fileUrl);
                    this.picBudgetFile.splice(index, 1);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getlookUpRentalType']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/lookup?ver=v1`;
            const param = {
                lookupKey: 'RentalType'
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, param)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setLookupRental', data);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['getlookUpOutstanding']() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiUrl = `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/lookup?ver=v1`;
            const param = {
                lookupKey: 'OutstandingReason'
            };
            return yield new Promise((resolve, reject) => {
                ApiService.post(apiUrl, param)
                    .then((response) => {
                    const data = response.data.result.content;
                    this.context.commit('setLookupOutstanding', data);
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        });
    }
    ['approvalCrfModule'](data) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const baseParams = {
                runWorkflowID: data.workflowId,
                approverID: String(data.employeeID),
                remarks: data.remarks
            };
            this.context.commit('setIsConfirmDraft', 'proceed');
            let params = {};
            if (data.isManagerFunction) {
                const listItems = [];
                data.itemRincian.forEach((g) => {
                    if (g.rentalType || g.mutationFrom || g.mutationQuantity) {
                        const newItem = {
                            detailItemId: g.detailItemID,
                            rentalType: g.rentalType || null,
                            mutationFrom: g.mutationFrom || null,
                            newOrderQuantity: parseInt(g.newOrderQuantity) === 0
                                ? 0
                                : parseInt(g.newOrderQuantity.split(',').join('')),
                            mutationQuantity: g.mutationQuantity
                                ? parseInt(g.mutationQuantity.split(',').join(''))
                                : null
                        };
                        listItems.push(newItem);
                    }
                });
                if (listItems.length !== 0) {
                    params = Object.assign(Object.assign({}, baseParams), { data: {
                            listItems
                        } });
                }
                else {
                    params = baseParams;
                }
            }
            else if (data.isPicBudget) {
                const base = data.conditions == 'outstanding'
                    ? {
                        headerId: data.headerId,
                        reasonCode: data.reasonCode,
                        remarks: data.remarks
                    }
                    : baseParams;
                const listAttachments = [];
                data.picBudgetFiles.forEach((g) => {
                    const newItem = {
                        attachmentID: g.attachmentID,
                        attachmentType: 'SUMMARYBUDGET',
                        originalFileName: g.originalFileName,
                        formattedFileName: g.formattedFileName,
                        fileType: g.fileType,
                        fileUrl: g.fileUrl
                    };
                    listAttachments.push(newItem);
                });
                params = Object.assign(Object.assign({}, base), { data: {
                        summaryBudget: data.summaryBudget || null,
                        listAttachments
                    } });
            }
            else if (data.isPicProcurement) {
                let merged = '';
                if (data.PICPRCSpendingValue) {
                    const biaya = data.PICPRCSpendingValue.split(',');
                    merged = biaya.join('');
                }
                const spendingValue = data.PICPRCSpendingValue ? merged : null;
                const baseData = {
                    PICPRCVendorId: data.PICPRCVendorId,
                    PICPRCPeriode: data.PICPRCPeriode.toString(),
                    PICPRCSpendingValueCurrency: data.PICPRCSpendingValueCurrency,
                    PICPRCSpendingValue: spendingValue
                };
                if (data.conditions == 'redirect') {
                    params = Object.assign(Object.assign({}, baseParams), { data: Object.assign({ PICPRCRedirectID: data.PICPRCRedirectID }, baseData) });
                }
                else {
                    params = Object.assign(Object.assign({}, baseParams), { data: Object.assign({}, baseData) });
                }
            }
            else {
                params = baseParams;
            }
            const subConditions = {
                all: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/askforrevision/reviseall?ver=v1`,
                creator: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/askforrevision/reviseonlycreator?ver=v1`,
                attachment: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/askforreviseattachment?ver=v1`,
                budget: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/askforrevisebudget?ver=v1`,
                '': `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/askforrevision?ver=v1`
            };
            const conditions = {
                approve: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/` +
                    data.conditions +
                    '?ver=v1',
                askforrevision: (_a = subConditions[data.subConditions]) !== null && _a !== void 0 ? _a : null,
                reject: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/reject?ver=v1`,
                outstanding: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/outstanding?ver=v1`,
                redirect: `${process.env.VUE_APP_BASE_URL_DIGITAL}/pscm-crf/api/crf/redirectpicprocurement?ver=v1`
            };
            return yield new Promise((resolve, reject) => {
                if (data.conditions == 'outstanding') {
                    ApiService.post(conditions[data.conditions], params)
                        .then((response) => {
                        const data = response.data.result.content;
                        this.context.commit('setCallbackError', Object.assign(Object.assign({}, response.data.result), { isField: data !== null }));
                        if (data !== null && response.data.result.isError) {
                            this.context.commit('setResetErrorTab');
                            data.errorSets.forEach((g) => {
                                switch (g.field.tabCode) {
                                    case 'tabCrf':
                                        this.context.commit('setErrorTabCrf', g);
                                        break;
                                    case 'tabRkk':
                                        this.context.commit('setErrorTabRkk', g);
                                        break;
                                    case 'tabLokasi':
                                        this.context.commit('setErrorTabLokasi', g);
                                        break;
                                    case 'tabRincian':
                                        this.context.commit('setErrorTabRincianInformasi', g);
                                        break;
                                    case 'tabAdditionalInfo':
                                        this.context.commit('setErrorTabAdditionalInfo', g);
                                        break;
                                }
                            });
                        }
                        else {
                            this.context.commit('setSubmissionLoading', false);
                            if (data.inProgress) {
                                this.context.commit('setSubmitInfoMessage', response.data.result.message);
                                this.context.commit('setSubmitInfoDialog', true);
                            }
                            else
                                this.context.commit('setSuccessDialog', true);
                            this.context.commit('setResetErrorTab');
                        }
                        resolve();
                    })
                        .catch((error) => {
                        reject(error);
                    });
                }
                else {
                    ApiService.put(conditions[data.conditions], params)
                        .then((response) => {
                        const data = response.data.result.content;
                        if (data === null && response.data.result.isError) {
                            this.context.commit('setSubmissionLoading', false);
                            this.context.commit('setShowErrorDialog', true);
                            this.context.commit('setIsSubmitError', {
                                conditions: false,
                                message: response.data.result.message,
                                isField: false
                            });
                        }
                        else if (data !== null && response.data.result.isError) {
                            this.context.commit('setSubmissionLoading', false);
                            this.context.commit('setResetErrorTab');
                            data.errorSets.forEach((g) => {
                                switch (g.field.tabCode) {
                                    case 'tabCrf':
                                        this.context.commit('setErrorTabCrf', g);
                                        break;
                                    case 'tabRkk':
                                        this.context.commit('setErrorTabRkk', g);
                                        break;
                                    case 'tabLokasi':
                                        this.context.commit('setErrorTabLokasi', g);
                                        break;
                                    case 'tabRincian':
                                        this.context.commit('setErrorTabRincianInformasi', g);
                                        break;
                                    case 'tabAdditionalInfo':
                                        this.context.commit('setErrorTabAdditionalInfo', g);
                                        break;
                                }
                            });
                        }
                        else {
                            this.context.commit('setSubmissionLoading', false);
                            if (data.inProgress) {
                                this.context.commit('setSubmitInfoMessage', response.data.result.message);
                                this.context.commit('setSubmitInfoDialog', true);
                            }
                            else
                                this.context.commit('setSuccessDialog', true);
                            this.context.commit('setResetErrorTab');
                        }
                        resolve();
                    })
                        .catch((error) => {
                        reject(error);
                    });
                }
            });
        });
    }
};
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setApprovalCrf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setPicBudgetFile', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setPicBudgetFileClear', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setEligable', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setCallbackError', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setLookupRental', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setLookupOutstanding', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setSubmitDialogApproval', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setSubmitPicProcDialog', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setSubmitClickApproval', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setCompleteInputMf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setHighlightMf', null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], CrfApprovalModule.prototype, 'setApprovalRemarkReq', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfApprovalModule.prototype, 'getApprovalCrfModule', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfApprovalModule.prototype, 'uploadPicBudgetFile', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfApprovalModule.prototype, 'deleteFilePicBudget', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfApprovalModule.prototype, 'getlookUpRentalType', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", Promise)
], CrfApprovalModule.prototype, 'getlookUpOutstanding', null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], CrfApprovalModule.prototype, 'approvalCrfModule', null);
CrfApprovalModule = __decorate([
    Module
], CrfApprovalModule);
export default CrfApprovalModule;
